import config from '../../../config';
import { getStepPos } from '../tools';

function initWarps (layer) {
  let g = this.g;

  let highlights = [];

  layer.groups.tiles.sort(function (a, b) {
    if (a.y === b.y) {
      return a.x - b.x;
    }
    return a.y - b.y;
  });

  _.each(layer.groups.tiles, (sprite, i) => {
    sprite.direction = parseFrameName(sprite.frame.name);
    if (i % 2 === 0) {
      sprite.warpTo = layer.groups.tiles[i + 1];
    } else {
      sprite.warpTo = layer.groups.tiles[i - 1];
    }
    sprite.play('warp-spin');
    let h = g.add.sprite(sprite.x, sprite.y, 'warp-enter-exit');
    h.setScale(0.5);
    h.setVisible(false);
    h.resetY = sprite.resetY;
    highlights.push(h);
    sprite.highlight = h;
  });

  layer.groups.highlights = highlights;
}

function parseFrameName (name) {
  return name.split('-').pop().replace('.png', '');
}

export {
  initWarps
};
